import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { blue, indigo, pink, deepOrange } from '@material-ui/core/colors';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import Routes from './Routes';
import 'Styles/global.scss';

const breakpoints = createBreakpoints({});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#45A358',
    },
    secondary: {
      main: '#58595B',
    },
    light: {
      main: '#fff',
    },
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    // fontFamily: ['"Roboto"', '"Lato"', 'sans-serif'].join(','),
    fontFamily: ['"Lato"', 'sans-serif'].join(','),
    fontSize: 16,
    color: '#4a4a4a',
    body1: {
      fontSize: 16,
    },
    h1: {
      fontSize: 38,
      lineHeight: '55px',
      fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
      fontWeight: 700,
      marginTop: '50px',
      marginBottom: '35px',
      [breakpoints.down('sm')]: {
        fontSize: '25px',
        marginTop: '40px',
      },
    },
    h2: {
      fontSize: 24,
      lineHeight: '55px',
      fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
      fontWeight: 700,
    },
    h3: {
      fontSize: 20,
      lineHeight: '32px',
      fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
      fontWeight: 700,
    },
    h4: {
      fontSize: 14,
      lineHeight: '32px',
      fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
      fontWeight: 700,
    },
    h5: {
      fontSize: 20,
      lineHeight: '15px',
      fontWeight: 600,
    },
    h6: {
      fontSize: 14,
      lineHeight: '15px',
      fontWeight: 700,
    },
    subtitle2: {
      fontWeight: 600,
    },
  },
  overrides: {
    MuiInput: {
      input: {
        fontFamily: ['"Roboto"', 'sans-serif'].join(','),
        fontSize: 20,
        lineHeight: '24px',
        '&::placeholder': {
          opacity: 1,
          color: '#9e9e9e',
        },
        '&:-webkit-autofill': {
          marginTop: '10px',
        },
      },
      inputMultiline: {
        minHeight: '1.1875em',
        lineHeight: '30px',
      },
    },
    MuiCheckbox: {
      root: {
        '& .MuiSvgIcon-root': {
          width: '25px',
          height: 'auto',
        },
      },
    },
    MuiFormLabel: {
      root: {
        fontFamily: ['"Roboto"', 'sans-serif'].join(','),
        fontSize: 20,
        lineHeight: '2px',
        color: '#9e9e9e',
        //marginBottom: 5,
      },
    },
    MuiInputLabel: {
      formControl: {
        transform: 'translate(0, 28px) scale(1)',
      },
    },
    MuiFormControl: {
      root: {
        marginTop: '20px',
      },
    },
    MuiFormHelperText: {
      root: {
        fontFamily: ['"Roboto"', 'sans-serif'].join(','),
        lineHeight: '28px',
        fontSize: 15,
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '500',
        fontSize: '20px',
        padding: '18px 30px',
      },
      contained: {
        boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
      },
      label: {
        lineHeight: 1,
      },
      sizeSmall: {
        fontSize: 16,
        lineHeight: '14px',
        padding: '8px 22px',
      },
    },
    MuiAlert: {
      action: {
        alignItems: 'flex-start',
      },
    },
  },
});

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Routes />
    </MuiThemeProvider>
  );
}

export default App;
